var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 24.574V40h-8.584V25.47c0-3.587-1.201-6.098-4.291-6.098-2.404 0-3.777 1.614-4.464 3.229-.172.538-.343 1.435-.343 2.152v15.068h-8.584s.172-24.395 0-26.906h8.584V16.86c1.201-1.794 3.261-4.484 7.725-4.484 5.837 0 9.957 3.946 9.957 12.197zM4.807 0C1.888 0 0 1.973 0 4.664c0 2.51 1.888 4.663 4.807 4.663 2.918 0 4.807-2.152 4.807-4.663C9.614 1.974 7.725 0 4.807 0zM.515 40h8.584V13.094H.515V40z",
    fill: "var(--a, #000)"
  })));
}

export default SvgLinkedin;